<template>
  <path
    d="M8,4v10M5.5,14h5M7,3H3L.5,8"
    fill="none"
    stroke="#fddc03"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width=".6667"
  />
  <path
    d="M8,4c.5523,0,1-.4477,1-1s-.4477-1-1-1-1,.4477-1,1,.4477,1,1,1Z"
    fill="none"
    stroke="#fddc03"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width=".6667"
  />
  <path
    d="M3,3l2.5,5M9,3h4M13,3l2.5,5M13,3l-2.5,5"
    fill="none"
    stroke="#fddc03"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width=".6667"
  />
  <path
    d="M3,10.5c.663,0,1.2989-.2634,1.7678-.7322.4688-.4688.7322-1.1047.7322-1.7678H.5c0,.663.2634,1.2989.7322,1.7678.2321.2321.5077.4163.8111.5419.3033.1256.6284.1903.9567.1903ZM13,10.5c-.663,0-1.2989-.2634-1.7678-.7322-.4688-.4688-.7322-1.1047-.7322-1.7678h5c0,.663-.2634,1.2989-.7322,1.7678-.4688.4688-1.1047.7322-1.7678.7322Z"
    fill="none"
    stroke="#fddc03"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width=".6667"
  />
</template>
